module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_wakayama-d5e898118bdbdf01f5ede1d6b798c736.png";